import React  from 'react';
import BounceLoader from "react-spinners/BounceLoader";
import "./pageLoader.styles.css"


const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
}

const PageLoader = (show) => {
    if (!show) return null;

    return (
        <div className='pageLoaderContainer'>

            <div className="loaderContainer">

                <BounceLoader 
                    color='green'
                    // loading={show}
                    size={250}
                    cssOverride={override}
                />

                <p className='loaderParagraph'>Loading </p>
            </div>
        </div>
    )
}

export default PageLoader